import { numberToLocale } from '@use-cases/districts';

export const getSign = (value: number) => (value >= 0 ? '+ ' : '- ');

export default (value: number) =>
  `${getSign(value)}${numberToLocale(Math.abs(value))}`;
